export const environment = {
  version: '9.2.0',
  production: false,
  sentryDsn: 'https://7a953713486f7d8f9c023a46cb73d85c@o4506308503273472.ingest.sentry.io/4506716251029504',
  deployUrl: 'https://pricing.calenso.io',
  brandName: 'Calenso',
  websiteUrl: 'https://www.calenso.com',
  supportEmail: 'support@calenso.com',
  componentTag: 'calenso-pricing-table',
  defaultLocale: 'de_CH',
};
